import Icon from "@/icons";
import Channel from "@/components/Channel/channel";
import { CreateChannel } from "@/components/Dialogs/CreateChannel";
import Tippy from "@tippyjs/react";
import UserBottom from "../Bottom/User";
import permissions from "@/permissions";
import { Link, useParams } from "react-router-dom";
import { ManageChannel } from "@/components/ContextMenu/Channel";
import { useEffect, useState } from "react";
import { TeamSettings } from "@/components/Dialogs/TeamSettings";
import getPermissionsById from "@/components/Dialogs/ChannelSettings/getPermissions";
import ErrorBoundary from "@/ErrorBoundary";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import { useQueryClient } from "@tanstack/react-query";
import { Channel as typeChannel } from "types";
export default function ChannelsSidebar({ socket, isOpen }: { socket: any, isOpen: any }) {
    const { teamId, channelId } = useParams();
    const [dropdown, setDropdown] = useState(false);
    let [, setTeamName] = useState("");
    const queryClient = useQueryClient();
    const [teamData, setTeamData] = useState<any>({});
    const channels = (queryClient.getQueryData(["team", teamId, "channels"]) as { channels: typeChannel[] })?.channels;
    const roles = (queryClient.getQueryData(["team", teamId, "roles"]) as { roles: any } | undefined)?.roles || [];
    const getMembers = queryClient.getQueryData(["team", teamId, "members"]) as any;
    const member = queryClient.getQueryState(["team", teamId, "members", "@me"]) as any;
    const teamDetails = queryClient.getQueryState(["team", teamId]) as any;
    const user = queryClient.getQueryData<any>(["user"])?.user as any;
    useEffect(() => {
        setTeamData(teamDetails?.data?.team);
    }, [teamDetails]);
    useEffect(() => {
        if (!socket) return;
        const handleteam = (event: MessageEvent) => {
            const data = JSON.parse(event.data);
            if (data.t === "TEAM_UPDATED" && data.d.team.id === teamId) {
                queryClient.setQueryData(["team", teamId], { ...teamDetails.data, team: data.d.team });
                setTeamName(data.d.team.name);
            }
        };

        socket.addEventListener("message", handleteam);
        return () => socket.removeEventListener("message", handleteam);
    }, [socket, teamId]);

    const onDragEnd = (result: any) => {
        if (!result.destination) return;
        const items = Array.from(channels);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);

        items.forEach((item: any, index) => {
            let channelLength = items.length;
            item.position = channelLength - index - 1;
        });

        fetch(`__SITE_BASE__/api/teams/${teamId}/channelspriority`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ channels: items.sort((a: any, b: any) => b.position - a.position) }),
        });

    }

    
    return (
        <div className={`sm:p-4 h-full relative flex flex-col sm:gap-8 ${isOpen == 2 ? 'z-10 flex' : 'hidden sm:flex'} transition-all duration-300 ease-linear`}>
            
            <div className="relative text-white p-4 sm:rounded-xl shadow-2xl w-full min-h-36 bg-gradient-to-r from-[#252525] to-[#161616]">
                <div
                    className="absolute inset-0 w-full h-full object-cover group-hover:blur-none transition-all duration-300 bg-center bg-cover bg-no-repeat rounded-lg"
                    style={{
                        backgroundImage: `url(${teamDetails?.data?.team?.banner})`,
                    }}
                />

                <div className="relative flex items-center justify-between z-10">
                    <div className="flex items-center gap-2 shadow-2xl shadow-black">
                        <span className="text-lg font-semibold">
                            {teamDetails?.data?.team?.name}
                        </span>
                        {teamDetails?.data?.team?.isVerified && (
                            <Tippy content="Verified Team">
                                <div className="items-center text-brand-green">
                                    <Icon name="verified" size="24" />
                                </div>
                            </Tippy>
                        )}
                    </div>

                    {(Boolean(BigInt(member?.data?.member?.permissions ?? '0') & (permissions.get("MANAGE_TEAM") && permissions.get("MANAGE_ROLES"))!)) &&
                        <div className="flex items-center gap-2 cursor-pointer" onClick={() => setDropdown(!dropdown)}>
                            <Icon name="arrowbottom" size="16" color="white" />
                        </div>
                    }
                </div>
            </div>

            {dropdown && (
                <div className="flex w-full absolute z-10">
                    <TeamSettings team={teamData} setTeamData={setTeamData} me={user} userpermissions={member?.data?.member?.permissions} setDropdown={setDropdown}>
                        <div className="absolute top-16 w-96 bg-brand-back rounded-lg shadow-lg">
                            <div className="flex items-center w-full gap-2 p-2 rounded-lg hover:bg-brand-darkest cursor-pointer transition-all duration-300">
                                <Icon name="settings" size="24" color="white" />
                                <h1 className="text-gray-300 font-semibold text-lg">Settings</h1>
                            </div>
                        </div>
                    </TeamSettings>
                </div>
            )}

            {Boolean(BigInt(member?.data?.member?.permissions ?? '0') & permissions.get("MANAGE_APPLICATIONS" as string)!) &&
            <div className={`flex-col bg-brand-dark shadow-2xl sm:rounded-xl ${isOpen == 2 ? 'z-10 flex' : 'hidden sm:flex'} transition-all duration-300 ease-linear`}>
                <div className="flex relative flex-col min-w-[19.5rem] sm:min-w-72 max-h-24 border-gray-600">
                    <div className="flex items-center gap-2 p-2 rounded-lg">
                        <Link to={`/teams/${teamId}/channels/applications`} className={` ${channelId == "applications" ? "bg-brand-darkest" : ""} group w-full justify-between min-h-8 min-w-8 flex items-center group gap-2 px-2 rounded-lg hover:bg-brand-darkest cursor-pointer`}>
                            <div className="flex items-center gap-2">
                                <Icon name="applications" size="16" color="white" />
                                <h1 className="text-gray-300 font-semibold text-base group-hover:text-white truncate">
                                    Applications
                                </h1>
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
            } 

            <div className={`flex-col h-full bg-brand-dark shadow-xl sm:rounded-lg ${isOpen == 2 ? 'z-10 flex' : 'hidden sm:flex'} transition-all duration-300 ease-linear`}>
                <ErrorBoundary>
                    <div className="flex flex-col rounded-lg flex-grow overflow-y-auto"
                        style={{ scrollbarWidth: "none", scrollbarColor: "rgb(40, 160, 42) rgb(27 27 29)" }}
                    >
                        <div className="flex relative flex-col min-w-[19.5rem] sm:min-w-72 max-h-24 border-gray-600">
                            {!channels ? (
                                [...Array(50)].map((_, index) => (
                                    <div key={index} className="flex flex-col gap-2 p-2 rounded-lg hover:bg-brand-darkest cursor-pointer">
                                        <div className="flex items-start gap-2 p-2 rounded-lg hover:bg-brand-darkest cursor-pointer">
                                            <div className="w-8 h-8 animate-pulse rounded-lg bg-gray-600 font-semibold text-lg" />
                                            <div className="w-52 h-8 animate-pulse rounded-lg bg-gray-600 font-semibold text-lg" />
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <DragDropContext onDragEnd={onDragEnd}>
                                    <Droppable droppableId="channels">
                                        {(provided) => (
                                            <div
                                                className="flex flex-col gap-2 py-2 flex-grow w-full"
                                                {...provided.droppableProps}
                                                ref={provided.innerRef}

                                            >
                                                <div className="p-2 items-center flex w-full">
                                                    <div className="items-center flex w-full justify-between">
                                                        <p className="font-semibold">Channels</p>
                                                        {(Boolean(BigInt(member?.data?.member?.permissions ?? '0') & permissions.get("MANAGE_CHANNELS" as string)!) &&
                                                            <CreateChannel>
                                                                <div className="flex items-center justify-center px-2 h-8 w-8 rounded-full transition-all duration-300">
                                                                    <Icon name="plus" size="36" color="white" />
                                                                </div>
                                                            </CreateChannel>
                                                        )}
                                                    </div>
                                                </div>
                                                {channels
                                                    ?.filter((channel: any) => !getPermissionsById({ teamData: teamDetails, userId: user?.id, channelData: channel, members: getMembers, roles: roles }).deny.includes("VIEW_CHANNEL"))
                                                    ?.map((channel: any, index: number) => (
                                                        <Draggable key={channel.id} draggableId={channel.id} index={index} isDragDisabled={!getPermissionsById({ teamData: teamDetails, userId: user?.id, channelData: channel, members: getMembers, roles: roles }).allow.includes("MANAGE_CHANNEL")}>
                                                            {(provided) => (
                                                                <div
                                                                    ref={provided.innerRef}
                                                                    {...provided.draggableProps}
                                                                    {...provided.dragHandleProps}
                                                                >
                                                                    {getPermissionsById({ teamData: teamDetails, userId: user?.id, channelData: channel, members: getMembers, roles: roles }).allow.includes("MANAGE_CHANNEL") ? (
                                                                        <ManageChannel channel={channel} key={channel.id}>
                                                                            <Channel channel={channel} hasPermission={
                                                                                getPermissionsById({ teamData: teamDetails, userId: user?.id, channelData: channel, members: getMembers, roles: roles }).allow.includes("MANAGE_CHANNEL")
                                                                            }/>
                                                                        </ManageChannel>
                                                                    ) : (
                                                                        <Channel key={channel.id} channel={channel} hasPermission={
                                                                            getPermissionsById({
                                                                                teamData: teamDetails,
                                                                                userId: user?.id,
                                                                                channelData: channel,
                                                                                members: getMembers,
                                                                                roles: roles
                                                                            }).allow.includes("MANAGE_CHANNEL")
                                                                        } />
                                                                    )}
                                                                </div>
                                                            )}
                                                        </Draggable>
                                                    ))}
                                                {provided.placeholder}
                                            </div>
                                        )}
                                    </Droppable>
                                </DragDropContext>
                            )}
                        </div>
                    </div>
                </ErrorBoundary>
            </div>
            <UserBottom user={{ user }} socket={socket} />
        </div>
    );
}
